/* eslint-disable camelcase */
import fetchCustomerLendingProfile from 'Utils/httpClients/fetchCustomerLendingProfile';
import { LoggerFactory, DOMAIN, FEATURE } from 'Services/Logger';
import { AxiosError, AxiosResponse } from 'axios';

export interface CustomerProfileApplications {
  status: string;
  can_continue: boolean;
}

const Logger = LoggerFactory.getLogger(DOMAIN.AMON);

export const getApplications = async (): Promise<CustomerProfileApplications> => {
  try {
    const response = await fetchCustomerLendingProfile(
      '/customer_lending_profile/api/v1/applications',
      'GET',
    ) as AxiosResponse<CustomerProfileApplications>;
    return response.data;
  } catch (error) {
    if ((error as AxiosError).response?.status !== 401) Logger.error('Error getting applications', `${FEATURE.PROFILE}.MENU`, { error });
    return Promise.reject(error);
  }
};
